import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl; // Assuming the apiUrl is defined in config.json.

const getIP = async (queryString) => {
  try {
    const url = `${apiUrl}/members/all-api-ip-list${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
const getIPById = async (id) => {
  try {
    const url = `${apiUrl}/members/ipaddress/${id}`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
const addIP = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/members/add-ip-address`,
      value
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
const deactivateIp = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/members/deactivate-ip`,
      value
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

// const deleteApplication = async (id, value) => {
//   try {
//     const { data } = await httpService.post(
//       `${apiUrl}/settings/application-settings/delete?Id=${id}`,
//       value
//     );
//     return data;
//   } catch (error) {
//     console.log(error);
//   }
// };

export { getIP, addIP, getIPById, deactivateIp };
